import type { ReactNode } from 'react';
import { cx } from './cx';

export type AlertTone = 'info' | 'warn';

export interface AlertProps {
  tone?: AlertTone;
  title?: string;
  children: ReactNode;
  className?: string;
}

const TONE_CLASS: Record<AlertTone, string> = {
  info: 'bg-sage-100 text-ink',
  warn: 'bg-alert-soft text-alert-ink',
};

/** Inline notice. `warn` gets `role="alert"` so screen readers announce it immediately. */
export const Alert = ({ tone = 'info', title, children, className = '' }: AlertProps) => (
  <div
    role={tone === 'warn' ? 'alert' : undefined}
    className={cx('rounded-md p-4 text-body', TONE_CLASS[tone], className)}
  >
    {title && (
      <p className={cx('mb-1 text-label', tone === 'warn' ? 'text-alert-ink' : 'text-ink')}>{title}</p>
    )}
    {children}
  </div>
);
